import React from "react";
import PropTypes from "prop-types";
import { Grid, Tooltip, Typography, withStyles, Hidden } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { FowardDialog, CommentDialog, FowardOptionsDialog } from "./DocDialogs";
import ApiCalendar from "react-google-calendar-api";
import { isTFAEnabled, TFAVerify } from "./2FA";
import '../index.css'
import withSnack from './withSnack'
import { Info } from '../img';

const SignTooltip = withStyles((theme) => ({
  popper:{
    zIndex: 1
  },
  tooltip: {
    padding: 0,
    backgroundColor: '#FFFFFF',
    fontSize: 11,
    border: '1px solid' + theme.palette.primary.main,
    '& p': {
      color: '#505050',
      padding: '5px 10px 5px 10px',
    },
    '& h6': {
      color: '#000',
      backgroundColor: '#9b90bd8c',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'normal',
      lineHeight: 2,
    },
    '& svg':{
      marginRight: 10,
      marginLeft: 10,
    },
    '&:before': {
      content: "' '",
      top: 'calc(50% - 6px)',
      left: '-20px',
      width: "1.2em",
      height: "1.2em",
      position: 'absolute',
      backgroundColor: '#FFF',
      marginLeft: '1.2em',
      transform: 'rotate(45deg)',
      borderColor: 'transparent transparent #694a8a #694a8a',
      borderStyle: 'solid',
      borderWidth: '1px',
    },
  },

}))(Tooltip);

export class DocActionButtons extends React.Component {
  state = {
    fowardDialog: false,
    fowardOptionsDialog: false,
    gapiDone: false,
    verifyDialog: false,
    commentDialog: false,
    ccList: [],
    ccNote: '',
    isTFAEnabled: isTFAEnabled(),
    showMessageError: false,
    errorMessage: '',
    option: 'normal',
    twoFASuccess: false
  };

  componentDidMount() {
    ApiCalendar.onLoad(() => {
      this.setState({ gapiDone: true });
    });
  }

  componentDidUpdate(prevState, nextState){
    const tfa = isTFAEnabled()
    if(nextState.isTFAEnabled !== tfa){
      this.setState({isTFAEnabled: isTFAEnabled()})
    }
  }

  closeFowardDialog = u => {
    this.setState({
      fowardDialog: false,
      twoFASuccess: false,
      ccList: [],
      ccNote: '',
      option: 'normal'
      });
  };

  closeFowardOpionsDialog = () => {
    this.setState({
      fowardOptionsDialog: false,
      twoFASuccess: false
    });
  };

  onGoodCode = () => {
    this.props.onPreview();
  };

  onFowardAuthorized = () => {
    this.setState({
      twoFASuccess: true
    });
  }

  openFowardDialog = (option) => {
    this.setState({
      fowardDialog: true,
      option: option
    });
  };

  openOptionsFoward = () => {
    this.setState({
      fowardOptionsDialog: true
    });
  }

  closeVerifyDialog = u => {
    this.setState({
      verifyDialog: false
    });
  };

  openVerifyDialog = u => {
    this.setState({
      verifyDialog: true,
      errorMessage: '',
      showMessageError: false
    });
  };

  closeCommentDialog = u => {
    this.setState({
      commentDialog: false
    });
  };

  openCommentDialog = u => {
    this.setState({
      commentDialog: true
    });
  };

  onAddCC = (event, {suggestion}) => {
    this.setState({value: ''})
    if (suggestion.temp === true){
      this.props.openTempModal(suggestion, 'fwd');
    }

    //this param breaks backend, this is the reason for delete it
    delete suggestion["temp"];
    this.setState(prevState => ({
      ccList: [...prevState.ccList, suggestion],
    }))
  }

  onAddExternalCC = (name, job_title) => {
    this.setState(prevState => ({
      ccList: [...prevState.ccList, { external: true, ext_name: name, ext_job_title: job_title }],
    }))
  }

  onDeleteCC = (f) => {
    this.setState(prevState => {
      return {ccList: prevState.ccList.filter(x => x.id !== f)}
    })
  }

  onCcNoteChange = n => {
    this.setState({
      ccNote: n
    })
  }

  checkErrors = (e) => {
    this.setState({ showMessageError: true })
    if(e === 'missing'){
      this.setState({
        errorMessage: 'Se necesita estar seleccionado al menos un destinatario, un asunto y tener como mínimo 50 caracteres en el contenido.'})
      }
      else{
        this.setState({
          errorMessage: 'Para enviar oficios es necesario activar la verificación de dos pasos en el menú.'})
        }
  }

  sendDocToAprove = (user) => {
    this.props.aproveDoc(user)
  }

  allowEdit = () => {
    this.props.editDoc();
  }

  onFoward = () => {
    const option = this.state.option;
    const users = this.state.ccList;
    const note = this.state.ccNote;
    const doc_id = this.props.docCC;
    const from_id = this.props.fromCC;
    let originalTo = '';

    if(this.props.needsReview.length > 0){
      originalTo = this.props.needsReview[0].id;
    }

    //**delete elements unnecessaries
    let users_new = users.map(({email,job_title,institution,name,signature,department, ...id}) => id)

    //**add _destroy and chage name to keys
    Object.keys(users_new).map(
      function(object){
        if(users_new[object]['group']){
          //**add new field to groups
          users_new[object]['user_group_id'] = users_new[object]['id']
          delete users_new[object]['group']
        }
        else{
          users_new[object]['to_id'] = users_new[object]['id']
        }
        delete users_new[object]['id']
        return users_new[object]["_destroy"]='false'
      }
    );

    //**loop to add an index to each user
    let notice_users_attributes = {}
    users_new.forEach(function(item,index){
      notice_users_attributes[index] = item;
    });

    //**create the structure
    const notice_attributes = { notices_attributes: { "0": {from_id: from_id,note: note, notice_users_attributes: notice_users_attributes}}};
    this.props.updateDocForward(doc_id, notice_attributes, option, originalTo)
  }

  replyDoc = (all) => {
    this.props.handleReplyDoc(this.props.docCC, all)
  }

  askPhysicalDoc = () => {
    this.props.handleAskPhysicalDoc()
  }

  render() {
    const {
      onPreview,
      onSendComment,
      onSendCommentApprove,
      noteAdded,
      previousNotes,
      role,
      docStatus,
      missingMinRequirements,
      to,
      disabled,
      onToChange,
      can_create,
      isDelegate,
      needsReview,
      authorize,
      needsRevision,
      fromCC,
      fromId,
      hasApprover,
      pendingApproval,
      can_trace,
      hasCC,
      userInCC,
      delegate_reply,
      belongs_to_group,
      forGroup,
      requested_physical,
      received_physical
    } = this.props;

    const {
      fowardDialog,
      gapiDone,
      verifyDialog,
      commentDialog,
      ccList,
      ccNote,
      isTFAEnabled,
      fowardOptionsDialog,
      option,
      twoFASuccess,
      errorMessage,
      showMessageError } = this.state;

    const revisor = role==="revisor";
    const delegated = role==="delegated";

    const signButtonText = role ==="delegated" && (docStatus === "rejected" || docStatus ==="inEdition") ? "Solicitar firma"
      : role ==="delegated"&& docStatus === "inRevision"? "Pendiente de firma"
      :role ==="revisor"&& docStatus === "rejected" ? "Pendiente de firma"
          : role === "isToUser" && docStatus === "inRevision" ? "Aprobar y enviar" : "Firmar y enviar";

    const revisionButtonText = (revisor && (docStatus === "rejected" || noteAdded)) ? "Notas de revisión" : (delegated || (hasApprover && (noteAdded || previousNotes.length > 0) ) )? "Notas de revisión": "Añadir nota"

    let action = onPreview;

     //handle when 2FA is enabled to show confirmation dialog
     if (isTFAEnabled === true && can_create === "true" && role !== 'delegated'){
       action = this.openVerifyDialog;
     }

    //handle when 2FA is disabled
    if (isTFAEnabled === false && can_create === "true" && role !== 'delagated'){
      action =  () => this.checkErrors('2FA');
    }

    //handle when missing min requirements
    if(missingMinRequirements){
      action =  () => this.checkErrors('missing');
    }

    //handle when case 'Solicitar firma' don't ask 2FA
    if(role === 'delegated' && missingMinRequirements === false){
      action = onPreview;
    }

    //2FA disabled on staging and development
    if(process.env.REACT_APP_DISABLED2FA === 'true' && missingMinRequirements === false){
      action = onPreview;
    }

    //handle revision
    let askRevision = null;
    let askRevisiontext = null;
    if((needsRevision === true) && (docStatus !== 'sent') && (docStatus !== 'inRevision') && (fromId === Number(fromCC)) && (role === 'owner')){

        askRevisiontext = 'Firmar y solicitar revisión';
        let innerAction = onPreview;

        if(missingMinRequirements){
         innerAction =  () => this.checkErrors('missing');
        }

        askRevision = (
          <Grid item className="signarea">
            <SignTooltip
              placement="right"
              open={showMessageError}
              title={
                <React.Fragment>
                  <Typography color="inherit" variant="subtitle2"><Info/>Para firmar y solicitar revisión de un oficio</Typography>
                  <p>{errorMessage}</p>
                </React.Fragment>
              }>
            <div>
              <Button
                onClick={innerAction}
                variant="contained"
                color="primary"
                >
                {askRevisiontext}
              </Button>
            </div>
            </SignTooltip>
          </Grid>
        );
    }
    else{
        askRevision = null;
    }

    let aproveButton = null;

    const arrayAproval = needsReview.length;

    if(arrayAproval > 0){
      aproveButton = (
        <Grid item>
          <Grid item>
            <Button
              onClick={() => this.sendDocToAprove(needsReview[0].id)}
              variant="contained"
              color="primary"
              >
              Aprobar oficio
            </Button>
          </Grid>
        </Grid>
      );
    }

    ////////normal forward
    const normalForward = () => this.openFowardDialog('normal')

    //render forward button
      let forwardButton = null;
      // if(((docStatus === "sent") || (arrayAproval > 0)) && (can_trace === "false"))  {
      if(docStatus === "sent"){
        forwardButton = (
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={authorize? this.openOptionsFoward : normalForward}>
            Reenviar
            </Button>
            <FowardOptionsDialog
              open={fowardOptionsDialog}
              onClose={this.closeFowardOpionsDialog}
              openDialog={this.openFowardDialog}
            />
            <FowardDialog
              open={fowardDialog}
              onClose={this.closeFowardDialog}
              onFoward={this.onFoward}
              to={to}
              disabled={disabled}
              onToChange={onToChange}
              onAddCC={this.onAddCC}
              onCcNoteChange={this.onCcNoteChange}
              ccList={ccList}
              ccNote={ccNote}
              onDeleteCC={this.onDeleteCC}
              option={option}
              onVerify2FA={this.openVerifyDialog}
              verified={twoFASuccess}
              onAddExternalCC={this.onAddExternalCC}/>
          </Grid>);
      }
    ///////

    //render revision button
    let revisionButton = null;
    if(docStatus !== "sent" && (role === "revisor" ||
        (role==="delegated" && docStatus==="rejected") ||
        (hasApprover === true && role !== "owner") ||
        (hasApprover === true && role === "owner" && previousNotes.length > 0 ))
      ){
        revisionButton = (
        <Grid item className="revisionarea">
            <React.Fragment>
              <Button
                variant="contained"
                color="primary"
                onClick={this.openCommentDialog}
              > { revisionButtonText}
              </Button>
              <CommentDialog
                open={commentDialog}
                onClose={this.closeCommentDialog}
                onSendComment={onSendComment}
                onSendCommentApprove={onSendCommentApprove}
                revisionNotes={this.revisionNotes}
                previousNotes={previousNotes}
                role={role}
                docStatus={docStatus}
                noteAdded={noteAdded}
                hasApprover={hasApprover}
              />
            </React.Fragment>
        </Grid>);
      }
    //////

    //render reply button
    let replyButton = null;

    if(docStatus === "sent" && can_create === "true" && (to.id === Number(fromCC) || userInCC || delegate_reply || belongs_to_group)){
        replyButton = (
        <Grid item className="replyarea">
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.replyDoc(false)}
              >Responder
              </Button>
        </Grid>);
      }
    //////

    //render replyall button
    let replyallButton = null;

    if(docStatus === "sent" && can_create === "true" &&  ((userInCC && hasCC) || (delegate_reply  && ( hasCC || forGroup ) ) || belongs_to_group)){
        replyallButton = (
        <Grid item className="replyarea">
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.replyDoc(true)}
              >Responder a todos
              </Button>
        </Grid>);
      }
    //////

    //render sign button
    let signButton = (
      <Grid item className="signarea">
        <SignTooltip
          placement="right"
          open={showMessageError}
          title={
            <React.Fragment>
              <Typography color="inherit" variant="subtitle2"><Info/>Para firmar un oficio</Typography>
              <p>{errorMessage}</p>
            </React.Fragment>
          }>
        <div>
         <Button
            variant="contained"
            color="primary"
            onClick={ action }>
            { signButtonText }
          </Button>
        </div>
        </SignTooltip>
      </Grid>
    );

    if(((docStatus=== "sent" || gapiDone === false)) ||
        (isDelegate === false && can_create === "false") ||
        (docStatus === "inRevision" && role === "delegated") ||
        (docStatus === "rejected" && role === "revisor") ||
        (noteAdded === true && (role === "revisor" || role === "isToUser")) ||
        (pendingApproval === true && fromId === Number(fromCC)) ||
        (needsRevision === true && role !== 'owner' && docStatus === "rejected" && role !== 'delegated' ) ||
        (docStatus === "inEdition" && role === 'owner' && needsRevision === true) ||
        (docStatus === "rejected" && role === "isToUser")
      ){
      signButton = null;
    }

    let editButton = null;

    if(docStatus === "inRevision" && (role === "isToUser" || role === "revisor")){
      editButton = (
        <Hidden only={['sm','xs']}>
          <Grid item>
            <Grid item>
              <Button
                onClick={this.allowEdit}
                variant="contained"
                color="primary"
                >
                  Editar
                </Button>
              </Grid>
            </Grid>
          </Hidden>
        );
      }

    let askPhysicalDocButton = null;

    // if(docStatus === "sent" && can_create === "true" && to.id === Number(fromCC) && !requested_physical && !received_physical){
    //   askPhysicalDocButton = (
    //       <Grid item>
    //         <Grid item>
    //           <Button
    //             onClick={this.askPhysicalDoc}
    //             variant="contained"
    //             color="primary"
    //             >
    //               Solicitar en físico
    //             </Button>
    //           </Grid>
    //         </Grid>
    //   );
    // }

    return (
      <React.Fragment>
        <Grid container spacing={8} className="action_buttons">
            {editButton}
            {forwardButton}
            {askRevision}
            {aproveButton}
            {replyButton}
            {replyallButton}
            {askPhysicalDocButton}
            <Grid item>
              <Grid container>
                {signButton}
                {revisionButton}
                <TFAVerify
                  open={verifyDialog}
                  onClose={this.closeVerifyDialog}
                  onContinue={this.state.option === 'authorize'? this.onFowardAuthorized : this.onGoodCode}/>
              </Grid>
            </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

DocActionButtons.propTypes = {
  role: PropTypes.string.isRequired,
  docStatus: PropTypes.string.isRequired
};
export default withSnack(DocActionButtons);



// WEBPACK FOOTER //
// ./src/components/DocActionButtons.js